import styled from 'styled-components';

import * as Common from '../../../Styles';

const Theme = Common.Theme;

export const Container = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	padding-bottom: 50px;
	z-index: 101;
	transition: 2s;
	background: ${Theme.container};
	box-shadow: 0 0 15px ${Theme.shadow};
`;

export const ContainerHeading = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	height: 2.5rem;
	padding: 10px 10px;
	background-color: ${Theme.white};
	font-size: 16px;
	font-weight: bold;
	justify-content: space-between;
	align-items: center;
`;

export const ContainerBody = styled.div`
	width: 100%;
	height: calc(100% - 56px);
	display: flex;
	justify-content: center;
	overflow: auto;
	scrollbar-width: thin;
	scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	&::-webkit-scrollbar-track {
		background: ${Theme.scrollBar};
	}
	&::-webkit-scrollbar-thumb {
		background: ${Theme.scrollThumb};
		border-radius: 5px;
		cursor: pointer !important;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: ${Theme.scrollThumb};
	}
	@media only screen and (max-width: 1080px) {
		align-items: center;
	}
`;

export const Section = styled(Common.FlexRow)`
	width: auto;
	background-color: ${Theme.white};
	margin: 0.5rem 2rem;
	border-radius: 5px;
	padding: 2rem;
	justify-content: center;
`;

export const Title = styled(Section)`
	margin-top: 2rem;
	padding: 2rem 1rem;
	gap: 12px;
	font-size: 18px;
	font-weight: bold;
	align-items: center;
	justify-content: left;
	background-color: ${(props) => (props.bgcolor ? props.bgcolor : '')};
	border: 2px solid ${(props) => (props.bordercolor ? props.bordercolor : 'transparent')};
`;

export const Description = styled(Section)`
	width: auto;
	background-color: ${Theme.white};
	border: 2px solid ${(props) => (props.bordercolor ? props.bordercolor : 'transparent')};
`;

export const Actions = styled(Section)`
	width: auto;
	background-color: ${Theme.white};
	gap: 12px;
`;

export const Bold = styled.span`
	margin: 0 2px;
	font-weight: 700;
	color: ${Theme.blue};
`;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const Button = styled(Common.Button)``;

export const ButtonWithLoader = styled(Common.ButtonWithLoader)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const CircularProgress = styled(Common.CircularProgress)``;

export const FileUpload = styled(Common.FileUpload)``;
